import type { ImportantNotice } from '@/data/types';

interface ImportantNoticesProps {
  notices: ImportantNotice[];
}

export function ImportantNotices({ notices }: ImportantNoticesProps) {
  return (
    <section className="bg-white py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {notices.map((notice, index) => (
          <div key={index} className="mb-8 last:mb-0">
            {/* Main notice messages in blue */}
            <div className="text-blue-600 text-lg font-medium space-y-4 mb-6">
              {notice.messages.map((message, messageIndex) => (
                <p key={messageIndex} className="leading-relaxed">
                  {message}
                </p>
              ))}
            </div>
            
            {/* Links section */}
            {notice.links.length > 0 && (
              <div>
                <p className="text-blue-600 font-medium mb-2">
                  Select the links below for more information:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  {notice.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a
                        href={link.url}
                        className="text-orange-500 hover:text-orange-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}